import { render, staticRenderFns } from "./QcB2BChannel.vue?vue&type=template&id=40a62837&scoped=true"
import script from "./QcB2BChannel.vue?vue&type=script&lang=js"
export * from "./QcB2BChannel.vue?vue&type=script&lang=js"
import style0 from "./QcB2BChannel.vue?vue&type=style&index=0&id=40a62837&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a62837",
  null
  
)

export default component.exports